import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "@/components/ui/sonner";
import LandingPage from './pages/LandingPage';
import WizardPage from './pages/WizardPage';
import CategoryPage from './pages/CategoryPage';
import ThanksPage from './pages/ThanksPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminCaseDetail from './pages/AdminCaseDetail';
import AdminSettings from './pages/AdminSettings';
import AdminCalibration from './pages/AdminCalibration';
import { AboutPage, TermsPage, ContactPage, PrivacyPage, CookiesPage, UserPolicyPage } from './pages/StaticPages';
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const isAuth = localStorage.getItem("admin_token");
  if (!isAuth) {
    return <Navigate to="/admin" replace />;
  }
  return children;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App font-sans text-slate-900">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Main */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/wizard" element={<WizardPage />} />
            <Route path="/tack" element={<ThanksPage />} />

            {/* Category pages */}
            <Route path="/målning" element={<CategoryPage slug="malning" />} />
            <Route path="/kök" element={<CategoryPage slug="kok" />} />
            <Route path="/våtrum" element={<CategoryPage slug="vatrum" />} />
            <Route path="/kakel" element={<CategoryPage slug="kakel" />} />
            <Route path="/golv" element={<CategoryPage slug="golv" />} />
            <Route path="/vvs" element={<CategoryPage slug="vvs" />} />
            <Route path="/el" element={<CategoryPage slug="el" />} />
            <Route path="/snickeri" element={<CategoryPage slug="snickeri" />} />

            {/* Admin */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/cases/:id"
              element={
                <ProtectedRoute>
                  <AdminCaseDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/settings"
              element={
                <ProtectedRoute>
                  <AdminSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/calibration"
              element={
                <ProtectedRoute>
                  <AdminCalibration />
                </ProtectedRoute>
              }
            />

            {/* Static Pages */}
            <Route path="/om-oss" element={<AboutPage />} />
            <Route path="/villkor" element={<TermsPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/integritet" element={<PrivacyPage />} />
            <Route path="/cookies" element={<CookiesPage />} />
            <Route path="/anvandarpolicy" element={<UserPolicyPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </HelmetProvider>
  );
}

export default App;
